import { getRemoteConfig, getValue } from 'firebase/remote-config';
import { firebaseApp } from 'firebaseConfig';
import { UseUserState } from 'store/user/useUser';

export type FeatureFlag = 'DELIVERY_PORTAL';

const getDeliveryPortalFeatureFlag = (): { countries: string[] } => {
  const featureFlag = getValue(getRemoteConfig(firebaseApp), 'DELIVERY_PORTAL');
  return JSON.parse(featureFlag.asString());
};

const userCanAccessDeliveryPortal = (user: UseUserState): boolean => {
  const { countries } = getDeliveryPortalFeatureFlag();

  if (!user.isAuthenticated) {
    return false;
  }

  return countries.some(country => country === user.region);
};

/**
 * If flag is undefined, returns true
 * @param flag
 * @param user
 * @returns
 */
export const featureFlagIsTrue = (flag: FeatureFlag | undefined, user: UseUserState): boolean => {
  switch (flag) {
    case 'DELIVERY_PORTAL':
      return userCanAccessDeliveryPortal(user);
    default:
      return true;
  }
};
